import { AfterViewInit, Component, ElementRef, Inject, OnInit, Renderer2, Type, ViewChild, ViewContainerRef, ViewRef } from '@angular/core';
import { ButtonComponentEvent } from '../button/button.component';
import { MultiTableColumn } from '../table.column';
import { WidgetComponent } from '../widget/widget.component';

@Component({
	selector: 'app-table-widget-menucolumn',
	templateUrl: './menucolumn.component.html',
	styleUrls: ['./menucolumn.component.css']
})
export class MenucolumnComponent extends WidgetComponent implements OnInit {

	viewContainerRef: ViewContainerRef;
	
	@ViewChild('menuContainer', {read: ViewContainerRef, static: true}) menuContainer: ViewContainerRef;

	// tslint:disable-next-line: deprecation
	constructor(
		ngEl: ElementRef,
		renderer: Renderer2,
		@Inject(ViewContainerRef) viewContainerRef: ViewContainerRef
	) {
		super(ngEl, renderer);

		this.viewContainerRef = viewContainerRef;
	}

	ngOnInit(): void {
		const multiColumn: MultiTableColumn = this.tableColumn as MultiTableColumn;

		if (multiColumn.nested) {
			multiColumn.nested.forEach(column => {
				let cellComponent: Type<WidgetComponent> = null;

				if (column.type && typeof(column.type) !== typeof('')) {
					if (column.checker) {
						if (column.checker(this.tableElement.getData()) === true) {
							cellComponent = column.type;
						} else {
							if (column.checkerType) {
								cellComponent = column.checkerType;
							}
						}
					} else {
						cellComponent = column.type;
					}
				}

				if (cellComponent) {
					this.table.dynamicComponent.addComponent(cellComponent, this.table, this.tableElement, column);
				}
			});

			let index = 0;
			for (index = this.table.dynamicComponent.container.length - 1; index >= 0; index--) {
				const view: ViewRef = this.table.dynamicComponent.container.detach(0);

				this.menuContainer.insert(view);
			}

			this.table.dynamicComponent.resetContainer();
		}
	}

	public getContent() {
	}

	onClicked($event: any): void {
		if ($event.screenX !== 0 || $event.screenY !== 0) {
			this.table.onButtonClicked(new ButtonComponentEvent(this.tableElement, this.tableColumn));
		}
		$event.stopPropagation();
	}
}
